import { createFeatureSelector } from '@ngrx/store';

import {
  recentSearchesFeatureName, RecentSearchesModuleState
} from '@recent-searches/store/state/recent-searches.state';

export const recentSearchesRootSelector = createFeatureSelector<RecentSearchesModuleState>(recentSearchesFeatureName);
